module.exports = ".my-drop-zone {\n    border: dotted 3px lightgray;\n}\n\n/* Default class applied to drop zones on over */\n\n.invalid-drag {\n    border: dotted 3px red;\n}\n\n.valid-drag {\n    border: dotted 3px green;\n}\n\nhtml, body {\n    height: 100%;\n}\n\n.previewIcon {\n    width: 100px;\n    height: 100px;\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.inline-block {\n    display: inline-block;\n    margin: .2em;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/control-app/shared/crear-notificacion/crear-notificacion.component.css
// module id = ./src/app/control-app/shared/crear-notificacion/crear-notificacion.component.css
// module chunks = main